import { Component, OnInit, OnDestroy } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { AmsNotifierService } from "../../services/ams-notifier.service";
import { LanguageService } from "../../services/language.service";
import { TransactionSignalRService } from "../../services/transaction-signalr.service";
import { UserService } from "../../services/user.service";
import { Transaction } from "./transaction";
import { TransactionErrorService } from "./transaction-error.service";

@Component({
  selector: "app-transaction-error",
  templateUrl: "./transaction-error.component.html",
  styleUrls: ["./transaction-error.component.css"]
})
export class TransactionErrorComponent implements OnInit, OnDestroy {
  canManageTransactionErrors = false;
  popupVisible = false;
  transactions: Transaction[];
  isBusy = false;
  hasSeenIncomingError = true;
  staticError = false;

  transactionsGridEnableFiltering =  false;
  transactionsGridColumns = null;
  transactionsGridPagingEnabled = true;
  transactionsGridHeight = 0;
  transactionsGridGroupPanelVisible = false;
  transactionsGridFirstGroupColumnDataField = null;

  showOpenCloseButtonsOnIndividualRows = true;

  private factories: string;
  private transactionUpdatedErrorListener: Subscription = null;
  private includePendingTransactions = false;

  constructor(public signalRService: TransactionSignalRService,
              public languageService: LanguageService,
              private userService: UserService,
              private transErrService: TransactionErrorService,
              private amsNotifierService: AmsNotifierService) {}

  ngOnInit() {
    if (this.userService.account.Mode == 1) {
      this.showOpenCloseButtonsOnIndividualRows = false;
    }
    this.setup();

    if (!this.canManageTransactionErrors) { return; }
    this.signalRService.connect(this.factories);
    this.transactionUpdatedErrorListener = this.signalRService.transactionUpdatedErrorListener$.subscribe(() => {
      this.hasSeenIncomingError = false;
    });
  }

  inspect(d: any) {
    
  }

  transactionGridCalculateGroupedTransactionIds(options: any) {
    if (options.name === "transactionId") {
      if (options.summaryProcess === "start") {
        options.totalValue = { statusId2Count: 0, transactionIds: [] };
      } else if (options.summaryProcess === "calculate") {
        if (options.value.TransactionStatusId == -2) {
          options.totalValue.statusId2Count++;
        }
        options.totalValue.transactionIds.push(options.value.TransactionId);
      }
    }
  }

  ngOnDestroy() {
    if (!this.canManageTransactionErrors) {return; }
    this.transactionUpdatedErrorListener.unsubscribe();
    this.signalRService.disconnect();
  }

  popupOnShowing(e: any) {
    const h = (e.component.option("height") - 90);
    this.transactionsGridHeight = h; //(window.innerHeight - 150);

  }

  popupOnHiding(e: any) {
    this.refreshStaticError(false);
  }

  showCloseOpenButton(td: any): boolean {
    if (td.column.groupIndex == 0 && td.column.dataField === this.transactionsGridFirstGroupColumnDataField && td.row.isExpanded && td.summaryItems != null && td.summaryItems.length == 1) {// && td != null && td.items) {
      //ALL grouped rows MUST have TransactionStatusId equal to -2 to show the "open" and "close" buttons
      return (td.summaryItems[0].value.statusId2Count == td.summaryItems[0].value.transactionIds.length);
    }
    return false;
  }

  errorsButtonClicked() {
    this.hasSeenIncomingError = true;
    this.popupVisible = true;
    this.load();
  }

  openTransaction(transaction: Transaction) {
    this.execute(transaction, this.transErrService.open(transaction.TransactionId, transaction.IsPending));
  }

  openTransactions(d: any) {
    if (d.summaryItems != null && d.summaryItems.length > 0) {
      var ids = d.summaryItems[0].value.transactionIds;

      if (ids != null && ids.length > 0) {
        this.transErrService.openMultiple(ids, this.includePendingTransactions).subscribe(() => {
          this.amsNotifierService.success(this.languageService.LNG("Label.SavedOk"));
          this.load();
        }, error => {
          this.amsNotifierService.error(typeof (error.message) !== "undefined" ? error.message : error);
          this.isBusy = false;
        });
      }
      else {
        this.amsNotifierService.warningWithTimeout("No transactions to open!");
      }
    }
  }

  closeTransaction(transaction: Transaction) {
    this.execute(transaction, this.transErrService.close(transaction.TransactionId, transaction.IsPending));
  }

  closeTransactions(d: any) {
    if (d.summaryItems != null && d.summaryItems.length == 1) {
      var ids = d.summaryItems[0].value.transactionIds;

      if (ids != null && ids.length > 0) {
        this.transErrService.closeMultiple(ids, this.includePendingTransactions).subscribe(() => {
          this.amsNotifierService.success(this.languageService.LNG("Label.SavedOk"));
          this.load();
        }, error => {
          this.amsNotifierService.error(typeof (error.message) !== "undefined" ? error.message : error);
          this.isBusy = false;
        });
      }
      else {
        this.amsNotifierService.warningWithTimeout("No transactions to close!");
      }
    }
  }

  private setup() {
    const setting = this.userService.account.SystemSettings._120;

    if (!setting) { return; }
    const split = setting.split(",");
    if (split.length !== 2) { return; }

    this.factories = split[0];
    this.canManageTransactionErrors = split[1].split(";").some(user => +user === this.userService.account.EmployeeId);

    let columns = [
      { dataField: "TransactionId", caption: "Id", groupIndex: undefined, autoExpandGroup: undefined, groupCellTemplate: "groupCellTemplate" },
      { dataField: "TransactionStatus.Code", caption: this.languageService.LNG('Label.Status'), sortOrder: "asc", groupCellTemplate: "groupCellTemplate" },
      { dataField: "Timestamp_Treated", caption: this.languageService.LNG('Label.Time'), dataType: "datetime", format: "dd.MM.yyyy HH:mm", groupCellTemplate: "groupCellTemplate" },
      { dataField: "TransactionFunctionCode", caption: 'Function', groupCellTemplate: "groupCellTemplate" },
      { dataField: "OrderNumber", caption: this.languageService.LNG('Label.Order'), groupCellTemplate: "groupCellTemplate" },
      { dataField: "OrderLineNumber", caption: this.languageService.LNG('Label.OrderLine'), groupCellTemplate: "groupCellTemplate" },
      { dataField: "CustomerNumber", caption: this.languageService.LNG('Label.Customer'), groupCellTemplate: "groupCellTemplate" },
      { dataField: "ContainerId", groupCellTemplate: "groupCellTemplate" },
      { dataField: "AssignmentNumber", caption: this.languageService.LNG('Label.Assignment'), groupCellTemplate: "groupCellTemplate" },
      { width: 400, dataField: "ErrorMessage", caption: this.languageService.LNG('Label.Message'), groupCellTemplate: "groupCellTemplate" },
      { width: 90, allowFiltering: false, allowGrouping: false, allowSorting: false, visible: this.showOpenCloseButtonsOnIndividualRows, cellTemplate: "buttonOpenTemplate" },
      { width: 90, allowFiltering: false, allowGrouping: false, allowSorting: false, visible: this.showOpenCloseButtonsOnIndividualRows, cellTemplate: "buttonCloseTemplate" },
    ];
    
    const setting2 = this.userService.account.SystemSettings._181;
    if (typeof (setting2) !== "undefined" && setting2 != null && setting2.trim().length > 0) {
      let s = setting2.split(";");//true;true;coloumn1,column2
      if (s.length == 4) {
        this.transactionsGridPagingEnabled = s[0].trim().toLowerCase() === "true";
        this.transactionsGridGroupPanelVisible = s[1].trim().toLowerCase() === "true";
        this.transactionsGridEnableFiltering = s[2].trim().toLowerCase() === "true";
        const sggbc: string[] = [];
        const splitt = s[3].split(",");
        for (let i = 0; i < splitt.length; i++) {
          sggbc.push(splitt[i].trim());
        }
        if (sggbc.length > 0) {
          this.transactionsGridFirstGroupColumnDataField = sggbc[0];
          for (let i = 0; i < columns.length; i++) {
            for (let j = 0; j < sggbc.length; j++) {
              if (columns[i].dataField == sggbc[j]) {
                columns[i].groupIndex = j;
                columns[i].autoExpandGroup = false;
                break;
              }
            }
          }
        }
      }
    }

    this.transactionsGridColumns = columns;
    this.refreshStaticError();
  }

  private load() {
    this.isBusy = true;
    this.transErrService.get(this.factories, this.includePendingTransactions).subscribe((transactions: Transaction[]) => {
      this.transactions = transactions;
      this.isBusy = false;
    }, error => {
      this.amsNotifierService.error(typeof(error.message) !== "undefined" ? error.message : error);
      this.isBusy = false;
      this.transactions = [];
    });
  }

  private refreshStaticError(doBlink = true) {
    if (typeof (this.userService.account.SystemSettings._18) !== 'undefined'
      && this.userService.account.SystemSettings._18 != null
      && this.userService.account.SystemSettings._18.toLowerCase() == "custom1") {
      this.includePendingTransactions = true;
      this.transErrService.get(this.factories, this.includePendingTransactions).subscribe((transactions: Transaction[]) => {
        const noErrorRecords = (transactions === null || transactions.length === 0);
        this.staticError = !noErrorRecords;
        if (doBlink) {
          this.hasSeenIncomingError = noErrorRecords;
        }
      }, error => {
        this.amsNotifierService.error(typeof (error.message) !== "undefined" ? error.message : error);
      });
    }
  }

  private execute(transaction: Transaction, method: Observable<any>) {
    const index: number = this.transactions.indexOf(transaction);

    if (index === -1) { return; }
    this.isBusy = true;
    method.subscribe(() => {
      this.transactions.splice(index, 1);
      this.amsNotifierService.success(this.languageService.LNG("Label.SavedOk"));
      this.isBusy = false;
    }, error => {
      this.amsNotifierService.error(typeof(error.message) !== "undefined" ? error.message : error);
      this.isBusy = false;
    });
  }
}
